import { Text } from '../Text'

export type ReportSectionHeaderProps = {
  fontSize?: number
}

export const ReportSectionHeader: React.FC<ReportSectionHeaderProps> = ({ children, fontSize = 16 }) => (
  <Text fontSize={`${fontSize}px`} bold color="white" p={2}>
    {children}
  </Text>
)
